<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
    <v-progress-linear
      :active="isAppLoading"
      :indeterminate="true"
      absolute
      :top="true"
      color="deep-orange darken-1"
    ></v-progress-linear>

    <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
      <v-app-bar-nav-icon @click.stop="toggleDrawer" />
      <span class="hidden-sm-and-down">Sylvan Learning</span>
    </v-toolbar-title>
    <v-spacer />

    <!-- <v-btn data-cy="login" to="/login" v-if="!isLoggedIn" icon title="Login">
      <v-icon>mdi-login</v-icon>
    </v-btn>
    <v-btn v-if="isLoggedIn" @click="logout" icon title="Logout">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
    <v-btn to="/register" v-if="!isLoggedIn" icon title="Register">
      <v-icon>mdi-account-plus</v-icon>
    </v-btn> -->

    <v-tooltip bottom>
      <template v-slot:activator="{on}">
      <v-btn v-on="on" to="/cart" icon>
        <v-icon>mdi-cart</v-icon>
        {{ numItems }}
      </v-btn>
      </template>
      <span v-if="numItems > 0">{{ numItems }} {{numItems > 1 ? 'items':'item'}} in your shopping cart</span>
      <span v-else>Shopping cart is empty</span>
    </v-tooltip>

    <v-divider v-if="isLoggedIn" class="mx-4" inset vertical></v-divider>

    <v-tooltip bottom v-if="isLoggedIn">
      <template v-slot:activator="{ on }">
        <v-chip outlined v-on="on">{{ currentUser.firstName.charAt(0) }}</v-chip>
      </template>
      <span>Logged in as {{ currentUser.firstName }}</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    drawer: null
  }),
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "isAdministrator",
      "cartValue",
      "currentUser",
      "cartItemList",
      "isAppLoading"
    ]),
    numItems() {
      return this.cartItemList.reduce((total, item) => {
        total += item.quantity;
        return total;
      }, 0);
    }
  },
  methods: {
    ...mapActions(["toggleDrawer", "hideDrawer"]),
    logout() {
      this.$axios.post("gaa-user/signout").then(() => {
        this.$store.commit("logout");
        localStorage.removeItem("token");
        delete this.$axios.defaults.headers.common["Authorization"];
        this.$router.push({name: "Login"});
      });
    }
  }
};
</script>

<style>
</style>